<template>
  <div class="theoryTestList-layer">
    <!--顶部-->
    <div class="top-layer">
      <div class="top1">
        <div class="txt">理论考试</div>
        <div class="backbtn" @click="Back">
          <img src="~@imgs/backup.png" />
          <div class="backtxt">返回</div>
        </div>
      </div>
      <div class="top2">
        <div class="txt">考试列表</div>
      </div>
    </div>
    <!--底部-->
    <div class="bottom-layer">
      <div class="style-table-wrap">
        <el-table :data="tableData" border style="width: 100%" :cell-class-name="cellClassName">
          <div slot="empty" :class="{ 'empty': !tableData.length }"></div>
          <el-table-column prop="time" label="考试时间" align="center" width="400">
            <div slot="header" class="table-header-item">
              <span>考试时间</span>
            </div>
            <template slot-scope="scope">
              {{ scope.row.time }}
            </template>
          </el-table-column>
          <el-table-column prop="testName" label="考试内容" align="center">
            <div slot="header" class="table-header-item">
              <span>考试内容</span>
            </div>
            <template slot-scope="scope">
              <div class="zuhelie">
                <div class="zuhelie-left">
                  <div class="zuhelie-name">第一章综合练习试卷</div>
                  <div class="zuhelie-zongfen">总分：120</div>
                  <div class="zuhelie-timu">题目：100</div>
                </div>
                <div class="zuhelie-right">
                  <div class="zuhelie-zhuangtai">未完成</div>
                  <!-- <div class="zuhelie-zhuangtai">79分</div> -->
                  <div class="zuhelie-btn" @click="StartPracticing(scope.row)">
                    <span>开始考试</span>
                    <!-- <span>未开始</span>
                    <span>查看记录</span> -->
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wrap">
        <el-pagination @current-change="getTableData" background layout="total,prev, pager, next"
                       :current-page.sync="param.pageIndex" :page-size="param.pageSize"
                       :total="totalNum"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'theoryPracticeList',
  components: {},
  props: {},
  data () {
    return {
      tableData: [{ time: '2025-02-21 10:30' }, { time: '2025-02-21 10:30' }, { time: '2025-02-21 10:30' }, { time: '2025-02-21 10:30' }, { time: '2025-02-21 10:30' },
      { time: '2025-02-21 10:30' }, { time: '2025-02-21 10:30' }, { time: '2025-02-21 10:30' }, { time: '2025-02-21 10:30' }, { time: '2025-02-21 10:30' }
      ],
      totalNum: 0,
      param: {
        pageIndex: 1,
        pageSize: 10
      },
      record: {
      },
    }
  },
  computed: {},
  watch: {},
  created () {
    //模拟有数据
    this.totalNum = this.tableData.length
  },
  mounted () { },
  methods: {
    cellClassName () {
      return 'warning-cell';
    },
    //开始练习
    StartPracticing () {
      this.Jump('/theoryPractice', { eid: 1, pid: 1 })
    },
    getTableData () { }
  }
}
</script>

<style scoped lang="less">
.theoryTestList-layer {
  padding: 20px 50px;

  .top-layer {
    display: flex;
    flex-direction: column;
    height: 80px;
    padding: 0 10px;
    border-bottom: 1px solid #dddddd;

    .top1 {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;

      .txt {
        font-size: 22px;
        font-weight: bold;
      }

      .backbtn {
        width: 80px;
        height: 30px;
        height: 30px;
        border: 1px solid #C8C7C9;
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 30px;
        cursor: pointer;

        img {
          display: block;
          width: 12px;
          height: 12px;
        }

        .backtxt {
          margin-left: 5px;
          font-size: 12px;
        }
      }
    }

    .top2 {
      .txt {
        font-size: 18px;
      }
    }
  }

  .bottom-layer {
    margin-top: 20px;
    height: calc(100% - 70px);

    .zuhelie {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 30px;
      padding-right: 15px;

      .zuhelie-left {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .zuhelie-name {
          margin-right: 15px;
          width: 150px;
          text-align: left;
          white-space: nowrap;
          /* 防止文本换行 */
          overflow: hidden;
          /* 隐藏超出容器的部分 */
          text-overflow: ellipsis;
          /* 显示省略号 */
          font-size: 14px;
          font-weight: bold;
        }

        .zuhelie-zongfen {
          margin-right: 15px;
          font-size: 14px;
        }

        .zuhelie-timu {
          font-size: 14px;
        }
      }

      .zuhelie-right {
        display: flex;

        .zuhelie-zhuangtai {
          margin-right: 80px;
        }

        .zuhelie-btn {
          cursor: pointer;
          color: #4568F7;
        }
      }
    }

    .pagination-wrap {
      margin-top: 10px;
      text-align: right;
    }
  }
}
</style>
